import React from 'react';

import Chip from "@mui/joy/Chip";
import Link from "@mui/joy/Link";

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';


class LeadCard extends React.Component {
    render() {
        if (this.props.mini || this.props.nano){
            return (
                <Chip
                    startDecorator={<ElectricBoltIcon />}
                >
                    <Link
                        href={'/lead/detail/'+this.props.lead.id}
                        target={'_blank'}
                        fontSize={'small'}
                    >
                        {this.props.lead.title.slice(0, 50)}
                    </Link>
                </Chip>
            )
        }
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: this.props.lead.title,
                            icon: <ElectricBoltIcon />,
                            linkPattern: '/lead/detail/:linkParam',
                            linkParam: this.props.lead.id,
                            flat: true,
                            fields: [
                                {
                                    title: 'Описание',
                                    value: this.props.lead.desc,
                                    html: true,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default LeadCard
